/**
 * assets/ecom-filter-scroll-fix.js
 *
 * Stops the collection page from jumping to the footer when a filter is
 * applied or reset.
 *
 * THE BUG: while EcomPoser's AJAX filter is loading it adds `ecom-doing-filter`
 * to the product row, and its CSS then sets the product container to
 * `display:none`. The page suddenly loses the whole product grid, so the
 * document shrinks to header + filters + footer and the browser clamps the
 * scroll position — the footer is now what's on screen. Browser scroll
 * anchoring then latches onto the footer, so when the new products are
 * inserted above it the page keeps scrolling to hold the footer in view.
 *
 * THE FIX:
 *  1. Keep the product grid in the layout while loading (dimmed and not
 *     clickable instead of display:none), so the page height doesn't collapse.
 *  2. Turn off scroll anchoring on the product area so it can't drag the
 *     viewport along when the grid is swapped.
 *  3. After the new results render, if the top of the results is above the
 *     viewport (e.g. the new result set is short), scroll back up to it.
 *
 * WHY THIS LIVES IN JS: the EcomPoser section/asset files are regenerated
 * whenever a page is re-published from the app, which would wipe any fix
 * made there.
 */
(function () {
  var HEADER_OFFSET = 100; // filter sidebar is sticky at top:90px

  var style = document.createElement('style');
  style.textContent =
    '.ecom-doing-filter .ecom-collection__product-container_collection{display:block !important;opacity:.4;pointer-events:none;transition:opacity .2s}' +
    '.ecom-collection__product-container_collection,.ecom-collection__product-main{overflow-anchor:none}';
  document.head.appendChild(style);

  function scrollToResults(row) {
    var target = row.querySelector('.ecom-collection__product-container_collection') || row;
    var top = target.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight) {
      window.scrollTo({ top: window.pageYOffset + top - HEADER_OFFSET, behavior: 'smooth' });
    }
  }

  function init() {
    if (!window.MutationObserver) return;
    var forms = document.querySelectorAll('.ecom-collection__filters-form');
    if (!forms.length) return;

    // Same element EcomPoser toggles `ecom-doing-filter` on.
    var rows = [];
    for (var i = 0; i < forms.length; i++) {
      var row = forms[i].closest('.ecom-row.ecom-section');
      if (row && rows.indexOf(row) === -1) rows.push(row);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var wasLoading = (m.oldValue || '').indexOf('ecom-doing-filter') !== -1;
        if (wasLoading && !m.target.classList.contains('ecom-doing-filter')) {
          scrollToResults(m.target);
        }
      }
    });
    for (var k = 0; k < rows.length; k++) {
      observer.observe(rows[k], { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
